// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__J1LZ1","heading":"Contact_heading__w1jyn"};